/* DARIA — رسالة تقسيط tabby (احتياطية)
   تختفي تلقائياً إذا كان ويدجت tabby الرسمي موجوداً. */
(function () {
  var SPLITS = 4, MIN = 100, MAX = 10000;

  function isAr() {
    return (document.documentElement.lang || 'ar').toLowerCase().indexOf('ar') === 0;
  }

  /* قراءة السعر مع تجاهل أي SVG (رمز الدرهم فيه أرقام في مساره) */
  function readPrice(el) {
    if (!el) return 0;
    var c = el.cloneNode(true);
    c.querySelectorAll('svg, metadata, style, script').forEach(function (n) { n.remove(); });
    var t = c.textContent || '';
    if (t.indexOf('<svg') > -1) t = t.replace(/<svg[\s\S]*?<\/svg>/gi, '').replace(/<[^>]+>/g, '');
    t = t.replace(/[\u0660-\u0669]/g, function (d) { return String.fromCharCode(d.charCodeAt(0) - 1584); });
    t = t.replace(/[^0-9.,]/g, '').replace(/,(?=\d{3}\b)/g, '').replace(',', '.');
    return parseFloat(t) || 0;
  }

  function fmt(n) {
    return n.toLocaleString(isAr() ? 'ar-AE' : 'en-AE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function build() {
    var slot = document.querySelector('[data-daria-tabby-slot]');
    if (!slot) return;
    if (document.querySelector('tabby-card, tabby-promo, .tabby-promo-snippet, [id*="tabbyPromo"]')) {
      slot.style.display = 'none';
      return;
    }
    var priceEl = document.querySelector('[data-price]');
    if (!priceEl) return;

    var box = slot.querySelector('.d-tabby');
    if (!box) {
      box = document.createElement('div');
      box.className = 'd-tabby';
      box.innerHTML = '<span class="d-tabby__logo">tabby</span><span class="d-tabby__txt"></span>';
      slot.appendChild(box);
    }

    var total = readPrice(priceEl);
    if (!total || total < MIN || total > MAX) { slot.style.display = 'none'; return; }
    slot.style.display = '';

    var per = total / SPLITS;
    var cur = isAr() ? 'د.إ' : 'AED';
    box.querySelector('.d-tabby__txt').textContent = isAr()
      ? 'قسّميها على ' + SPLITS + ' دفعات بدون فوائد — ' + fmt(per) + ' ' + cur
      : 'Split in ' + SPLITS + ' interest-free payments of ' + fmt(per) + ' ' + cur;
  }

  function start() {
    build();
    var priceEl = document.querySelector('[data-price]');
    if (!priceEl || priceEl.dataset.tabbyWatch) return;
    priceEl.dataset.tabbyWatch = '1';
    new MutationObserver(build).observe(priceEl, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start, { once: true });
  document.addEventListener('shopify:section:load', start);
})();
